<h1 mat-dialog-title>Info</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onDialogClose()" cdkFocusInitial>Ok</button>
</div>
